<div class="upgrade-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon class="header-icon">upgrade</mat-icon>
      {{'UPGRADE_SUBSCRIPTION_TITLE' | translate}}
    </h2>
    <button mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Current Subscription Info -->
    <div class="current-subscription-section" *ngIf="currentSubscription">
      <h3>{{'CURRENT_PLAN' |translate}}</h3>
      <div class="current-plan-card">
        <div class="plan-info">
          <p class="plan-name">Current Subscription</p>
          <p class="plan-details">
            Duration: {{ currentSubscription.duration || 0 }} months | 
            Amount: {{ formatCurrency(currentSubscription.total_amount || 0) }}
          </p>
        </div>
      </div>
    </div>

    <!-- Domain Selection -->
    <section class="domain-selection-section">
      <label class="section-label">{{'CHOOSE_DOMAINS' |translate}}</label>
      <div class="domain-grid">
        <div
          *ngFor="let domain of domains"
          class="domain-card"
          [ngClass]="{
            'selected': selectedDomains.includes(domain.name)
          }"
        >
          <div class="domain-checkbox">
            <mat-checkbox
              [checked]="selectedDomains.includes(domain.name)"
              (change)="onDomainChange($event)"
              [value]="domain.name"
            ></mat-checkbox>
          </div>
          <h3 class="domain-name">{{ domain.name }}</h3>
          <!-- <p class="domain-price">{{ formatCurrency(domain.price) }} {{ domain.unit }}</p> -->
          <!-- <p class="domain-description" *ngIf="domain.description">{{ domain.description }}</p> -->
        </div>
      </div>
    </section>

    <!-- Subscription Form -->
    <form [formGroup]="upgradeForm" class="upgrade-form">
      <!-- General Info -->
      <div class="form-row">
        <div class="form-field">
          <label class="field-label">{{'ORGANIZATION_CODE' | translate}}</label>
          <input
            formControlName="organization_code"
            type="text"
            readonly
            class="form-input"
          />
        </div>

        <div class="form-field">
          <label class="field-label">{{'DURATION_MONTHS' | translate}} *</label>
          <select
            formControlName="duration"
            class="form-input"
          >
            <option *ngFor="let month of monthOptions" [value]="month">
              {{ month }} month{{ month > 1 ? "s" : "" }}
            </option>
          </select>
        </div>
      </div>

      <!-- Dynamic Domain Sections -->
      <ng-container
        *ngFor="let domain of ['Consultancy', 'Road', 'Construction', 'Utilities']"
      >
        <div
          *ngIf="selectedDomains.includes(domain)"
          [formGroupName]="domain"
          class="domain-config-section"
        >
          <h3 class="domain-config-title">{{ domain }} Details</h3>
          <div class="domain-config-fields">
            <div class="form-field">
              <label class="field-label">{{'USERS' | translate}}</label>
              <input
                formControlName="users_count"
                type="number"
                placeholder="Users Count"
                min="0"
                class="form-input"
                (input)="calculateTotal()"
              />
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Calculation Summary -->
      <div class="calculation-summary" *ngIf="orderTotal > 0">
        <h4>Order Summary</h4>
        <div class="summary-card">
          <div class="summary-row">
            <span>Subtotal:</span>
            <span>{{ formatCurrency(subtotal) }}</span>
          </div>
          <div class="summary-row">
            <span>GST (18%):</span>
            <span>{{ formatCurrency(gstAmount) }}</span>
          </div>
          <div class="summary-row total-row">
            <span><strong>New plan total:</strong></span>
            <span><strong>{{ formatCurrency(orderTotal) }}</strong></span>
          </div>
          <div class="summary-row total-row" *ngIf="upgradeDetails">
            <span><strong>Amount due now:</strong></span>
            <span><strong>{{ formatCurrency(amountDue) }}</strong></span>
          </div>
        </div>

        <!-- Upgrade Details -->
        <div class="upgrade-info" *ngIf="upgradeDetails && newEndDate">
          <h4>Upgrade Information</h4>
          <div class="info-card">
            <div class="info-row">
              <span>Upgrade Type:</span>
              <span>Prorated (Immediate)</span>
            </div>
            <div class="info-row" *ngIf="upgradeDetails.prorated_days">
              <span>Remaining Days:</span>
              <span>{{ upgradeDetails.prorated_days }} days</span>
            </div>
            <div class="info-row">
              <span>New Subscription End Date:</span>
              <span><strong>{{ newEndDate | date:'mediumDate' }}</strong></span>
            </div>
            <div class="info-note">
              <mat-icon>info</mat-icon>
              <span>Your subscription will be extended from the current end date based on the new plan duration.</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="close()" [disabled]="loading">{{'CANCEL' | translate}}</button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="proceedToPayment()"
      [disabled]="selectedDomains.length === 0 || orderTotal === 0 || loading"
    >
      <mat-spinner diameter="20" *ngIf="loading" class="button-spinner"></mat-spinner>
      <span *ngIf="!loading">{{'PROCEED_TO_PAY' | translate}}</span>
      <span *ngIf="loading">Processing...</span>
    </button>
  </mat-dialog-actions>
</div>

